export const PersonalDoctorAppointmentName = 'Консультація персонального лікаря';

export interface DoctorProfile {
  id: string;
  phoneNumber: string;
  phoneCode: string;
  firstName: string;
  lastName: string;
  middleName: string;
  fullName: string;
  helsiDoctorId: string;
  dobrobutDoctorId: string;
  specializations: string[];
  address: string;
  company: string;
  usreouCode: string;
  license: string;
  city: string;
  email: string;
  country: string;
  gender: string;
  birthDate: string;
  isActive: boolean;
  experienceInYears: number;
  profilePhotoIdXs: string;
  profilePhotoIdFull: string;
  profilePhotoPath: string;
  locationId: string;
  description: string;
  dynamicContentSections: DynamicContentSection[];
}

// TODO: maybe should be combined with common Doctor & renamed
export interface PersonalDoctor {
  id: string;
  partnerId: string;
  fullName: string;
  specialization: string;
  specializations: string[];
  experienceInYears: number;
  isPersonalDoctor: boolean;
  isPopular: boolean;
  active: boolean;
  available: boolean;
  importStatus: string;
  updateStatus: string;
  createdAt: string;
  updatedBy: string;
  updatedAt: string;
}

export interface DynamicContentSection {
  title: string;
  type: string;
  elements: string[];
}

export interface TimeSlotModel {
  slotId: string;
  start: string;
  end: string;
  startDate: string; // ISO date string representing DateTime
  endDate: string; // ISO date string representing DateTime
}

export interface DailySlotsModel {
  slotDate: string;
  date: string;
  dayOfWeek: number;
  timeSlots: TimeSlotModel[];
}

export interface ServiceScheduleSlotsModel {
  serviceId: string;
  workDays: DailySlotsModel[];
  partnerId: string;
}

export interface ServiceScheduleSlotsModel {
  serviceId: string;
  workDays: DailySlotsModel[];
  partnerId: string;
}

// Placeholder for NextVisitModel – update with real properties if available
export interface NextVisitModel {
  // TODO: Define properties for the next visit information as needed
}

export interface DoctorWithScheduleModel {
  workDays: DailySlotsModel[];
  doctorId: string;
  doctorLogin: string;
  name: string;
  specialities: string[];
  address?: string;
  nextVisit: NextVisitModel;
  companyGuid: string;
  distance?: number;
  latitude?: number;
  longitude?: number;
  recentlyVisited: boolean;
  isPopular: boolean;
  partnerId: string;
}
